import { ChevronUp, ChevronDown, ChevronsUpDown } from 'lucide-react';
import type { SortDir } from '../../hooks/useTableSort';

interface Props {
  label: string;
  sortKey: string;
  activeKey: string | null;
  dir: SortDir | null;
  onSort: (key: string) => void;
  className?: string;
  children?: React.ReactNode;
}

export function SortableColHeader({ label, sortKey, activeKey, dir, onSort, className = '', children }: Props) {
  const isActive = sortKey === activeKey;

  return (
    <button
      type="button"
      onClick={() => onSort(sortKey)}
      className={`inline-flex items-center gap-1 select-none cursor-pointer
                  hover:text-blue-600 transition-colors ${className}`}
    >
      {children}
      {label}
      {isActive && dir ? (
        dir === 'asc'
          ? <ChevronUp className="w-3 h-3 text-blue-600" />
          : <ChevronDown className="w-3 h-3 text-blue-600" />
      ) : (
        <ChevronsUpDown className="w-3 h-3 text-gray-300" />
      )}
    </button>
  );
}
